import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { ReactNode } from 'react';
import styles from './StructuredTaskDetails.module.scss';

export interface StructuredTableColumn {
  key: string;
  label: string;
}

export const StructuredTaskPanel = ({ children }: { children: ReactNode }) => {
  return (
    <Paper elevation={0} className={styles.StructuredTaskPanel}>
      {children}
    </Paper>
  );
};

export const StructuredTaskSection = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <Box className={styles.StructuredTaskSection}>
      <Box className={styles.StructuredTaskSectionHeader}>
        <span className={styles.StructuredTaskSectionTitle}>{title}</span>
      </Box>
      {children}
    </Box>
  );
};

export const StructuredTaskFieldRow = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <Box className={styles.StructuredTaskFieldRow}>{children}</Box>;
};

export const StructuredTaskField = ({
  label,
  value,
  emphasized = false,
}: {
  label: string;
  value: ReactNode;
  emphasized?: boolean;
}) => {
  return (
    <Box
      className={`${styles.StructuredTaskField} ${
        emphasized ? styles.StructuredTaskFieldEmphasized : ''
      }`}
    >
      <span className={styles.StructuredTaskFieldLabel}>{label}</span>
      {emphasized ? (
        <div className={styles.StructuredTaskFieldValueEmphasized}>{value}</div>
      ) : (
        <div className={styles.StructuredTaskFieldValue}>{value}</div>
      )}
    </Box>
  );
};

export const StructuredTaskDataTable = ({
  columns,
  rows,
  rowKey,
}: {
  columns: StructuredTableColumn[];
  rows: Record<string, ReactNode>[];
  rowKey: (row: Record<string, ReactNode>, index: number) => string;
}) => {
  return (
    <Table size="small" className={styles.StructuredTaskTable}>
      <TableHead>
        <TableRow>
          {columns.map(column => (
            <TableCell
              key={column.key}
              className={styles.StructuredTaskTableHeadCell}
            >
              <div className={styles.StructuredTaskTableHeadLabel}>
                {column.label}
              </div>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, rowIndex) => (
          <TableRow
            key={rowKey(row, rowIndex)}
            className={styles.StructuredTaskTableRow}
          >
            {columns.map(column => (
              <TableCell
                key={`${rowKey(row, rowIndex)}-${column.key}`}
                className={styles.StructuredTaskTableCell}
              >
                <div className={styles.StructuredTaskTableValue}>
                  {row[column.key]}
                </div>
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
